import { gql } from "@apollo/client";

export const GET_CLINICAL_HISTORIES_BY_PATIENT_ID = gql`
  query ClinicalHistoriesByPatientId($patient_id: ID!) {
    clinicalHistoriesByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      weight
      height
      note
      conditions
      quality_of_life_indicators
      custom_quality_of_life_indicators
      createdAt
      updatedAt
    }
  }
`;

export const GET_CLINICAL_HISTORY_BY_ID = gql`
  query ClinicalHistoryById($id: ID!) {
    clinicalHistoryById(_id: $id) {
      _id
      patient_id
      weight
      height
      note
      conditions
      quality_of_life_indicators
      custom_quality_of_life_indicators
      createdAt
      updatedAt
    }
  }
`;

export const GET_CLINICAL_HISTORIES_BY_IDS = gql`
  query ClinicalHistoriesByIds($ids: [ID!]!) {
    clinicalHistoriesByIds(ids: $ids) {
      _id
      patient_id
      weight
      height
      note
      conditions
      quality_of_life_indicators
      custom_quality_of_life_indicators
      createdAt
      updatedAt
    }
  }
`;
